import { carts } from './carts'
import { cases } from './cases'
import { funeralHomes } from './funeralHomes'
import { flowerstore } from './flowerstore'
import { obituaries } from './obituaries'
import { obituaryMemories } from './obituaryMemories'
import { obituaryMemoryComments } from './obituaryMemoryComments'
import { obituarySnippets } from './obituarySnippets'
import { reactions } from './reactions'
import { veteranContact } from './veteranContact'
import { visitorUsers } from './visitorUsers'

export const API = {
  carts,
  cases,
  funeralHomes,
  flowerstore,
  obituaries,
  obituaryMemories,
  obituaryMemoryComments,
  obituarySnippets,
  reactions,
  veteranContact,
  visitorUsers,
}
